import { lazy } from 'react';
import SSOIframe from '../agency/SSOIframe';
const Agency = lazy(() => import('../agency'));
const Location = lazy(() => import('../location'));

// SnapshotCustomPages;
export default function useRoutes() {
    return [
        {
            route: '/app/iframe',
            component: <SSOIframe />,
        },
        {
            path: '/agency/:company_id/:planId/:userId/*',
            element: <Agency />,
        },
        {
            path: '/location/:company_id/:locationId/*',
            element: <Location />,
        },
    ];
}